import React from 'react';

export default function VerifyBadge({ size = 'sm' }) {
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      padding: size === 'sm' ? '2px 7px' : '3px 9px',
      borderRadius: 4, fontSize: size === 'sm' ? 11 : 12, fontWeight: 600,
      color: '#047857', background: '#ECFDF5', border: '1px solid #6EE7B722',
    }}>
      <svg width="9" height="9" viewBox="0 0 10 10" fill="currentColor">
        <path d="M4.5 8.5L1 5l1-1 2.5 2.5 4.5-4.5 1 1z"/>
      </svg>
      Verified
    </span>
  );
}
